export default __webpack_public_path__ + "static/media/pubg-mobile.f3b762e7.png";